export default __webpack_public_path__ + "static/media/mode-36.6d0b3393.svg";